import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./ga4";

export const GA4RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location);
  }, [location.pathname, location.search, location.hash]);

  return null;
};
